<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import PostSaleStatusDetailSection from './PostSaleStatusDetailSection.vue';
import { first, payloadOf, textOf } from './postSaleStatusDetailPresenter';

const props = defineProps({ event: { type: Object, required: true } });
const { t } = useI18n();
const items = computed(() => {
  const payload = payloadOf(props.event);
  const responsible = first(payload.responsaveis_venda);

  return [
    {
      label: t('POST_SALE.STATUS_DETAILS.BUYER_RESPONSIBLE'),
      value: textOf(
        responsible.nome_comprador || payload.responsavel_comprador,
        t('POST_SALE.COMMON.EMPTY_VALUE'),
        t
      ),
    },
  ];
});
</script>

<template>
  <PostSaleStatusDetailSection
    :title="t('POST_SALE.STATUS_DETAILS.PEOPLE')"
    :items="items"
  />
</template>
